/**
 * Data provider già usato dal modulo Bi: `getById('configuration')` → GET `/bis/bi/configuration`.
 */
export const DASHBOARD_REPORT_CONFIGURATION_DATA_PROVIDER = 'bis/bi';

/**
 * Segmento URL e, in Redux, chiave preferita in `global.items[_id]` dopo GETONE
 * (richiede `item.data._id` coerente nella risposta API).
 */
export const DASHBOARD_REPORT_CONFIGURATION_DOCUMENT_ID = 'configuration';
